




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CountdownComponent extends Vue {
  @Prop(String) private readonly targetDate!: string;

  private timeLeftDisplay: string = '';
  private timerIntervalHandle: number | null = null;

  private updateTimeLeft() {
    const now = new Date().getTime();
    const exp = new Date(this.targetDate).getTime();

    // quick&dirty timer update
    let seconds = Math.floor((exp - now) / 1000);

    const days = Math.floor(seconds / 86400);
    seconds -= days * 86400;

    const hours = Math.floor(seconds / 3600) % 24;
    seconds -= hours * 3600;

    const minutes = Math.floor(seconds / 60) % 60;
    seconds -= minutes * 60;

    if (seconds.toString() === 'NaN') {
      this.timeLeftDisplay = '';
      return;
    }

    const parts: string[] = [];

    if (days > 0) {
      parts.push(`${days}d `);
    }

    if (hours > 0) {
      parts.push(`${hours}h `);
    }

    parts.push(
      `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`,
    );

    this.timeLeftDisplay = parts.join();
  }

  private mounted() {
    this.timerIntervalHandle = window.setInterval(this.updateTimeLeft, 1000);
    this.updateTimeLeft();
  }

  private destroyed() {
    if (this.timerIntervalHandle !== null) {
      clearInterval(this.timerIntervalHandle);
      this.timerIntervalHandle = null;
    }
  }
}
